import { Link } from "react-router-dom";
import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import FooterNew from "@/components/FooterNew";

const LAST_UPDATED = "3 de julho de 2026";

const TLDR = [
  "O site é canal de apresentação e contratação dos meus serviços; o conteúdo é informativo e comercial.",
  "Todo o conteúdo pertence a Eliveuton Souza — reprodução ou uso comercial exige autorização prévia.",
  "Orçamentos e contratos são formalizados individualmente, por proposta com assinatura eletrônica.",
];

const sectionTitle = "font-display text-[17px] font-bold tracking-[-.02em] text-foreground";
const sectionBody = "mt-2.5 text-[14.5px] leading-[1.75] text-muted-foreground";
const linkClass = "text-primary underline hover:no-underline";

const TermosDeUso = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOMeta
        title="Termos de Uso"
        description="Condições de uso do site e dos serviços de Eliveuton Dev — desenvolvimento web, automação e consultoria."
        canonicalUrl="/termos-de-uso"
      />
      <NavbarNew />

      <main className="px-6 pb-20 pt-10">
        <div className="mx-auto max-w-[720px]">
          <div className="rounded-[18px] border border-border bg-card p-6 shadow-card sm:p-[36px_40px]">
            <p className="text-xs font-bold uppercase tracking-[.06em] text-muted-foreground">
              Atualizada em {LAST_UPDATED}
            </p>
            <h1 className="mt-2.5 font-display text-[28px] font-bold tracking-[-.03em] text-foreground">
              Termos de Uso
            </h1>
            <p className="mt-3.5 text-[15px] leading-[1.75] text-muted-foreground">
              Em resumo: o site é informativo, o conteúdo é meu, e contratar serviço só acontece por
              proposta e contrato assinados — nada aqui vincula por si só.
            </p>

            <div className="mt-6 rounded-[13px] border border-primary bg-accent px-5 py-[18px]">
              <p className="text-[12.5px] font-bold text-primary">O essencial em 3 linhas</p>
              <div className="mt-2.5 flex flex-col gap-2">
                {TLDR.map((line) => (
                  <div key={line} className="flex items-start gap-2.5">
                    <span className="mt-0.5 text-xs font-bold text-primary">•</span>
                    <span className="text-[13.5px] leading-[1.55] text-foreground">{line}</span>
                  </div>
                ))}
              </div>
            </div>

            <section className="mt-7">
              <h2 className={sectionTitle}>1. Aceitação dos termos</h2>
              <p className={sectionBody}>
                Ao acessar e usar o site{" "}
                <strong className="text-foreground">eliveutonsouza.com</strong>, você concorda com
                estes Termos de Uso. Se não concordar com algum item, recomendamos não utilizar o
                site. Este documento se aplica em conjunto com a nossa{" "}
                <Link to="/politica-de-privacidade" className={linkClass}>
                  Política de Privacidade
                </Link>
                .
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>2. Sobre o site e os serviços</h2>
              <p className={sectionBody}>
                Este site é um canal de apresentação e contratação dos serviços de{" "}
                <strong className="text-foreground">Eliveuton Souza (Eliveuton Dev)</strong>:
                desenvolvimento de sites e sistemas, automação com inteligência artificial e
                consultoria em tecnologia. As informações publicadas — incluindo textos, imagens,
                projetos e blog — têm caráter informativo e comercial.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>3. Propriedade intelectual</h2>
              <p className={sectionBody}>
                Todo o conteúdo do site (textos, layout, logotipo, imagens e código-fonte da própria
                plataforma) pertence a Eliveuton Souza, salvo quando indicado de outra forma. É
                proibida a reprodução, distribuição ou uso comercial sem autorização prévia.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>4. Uso aceitável</h2>
              <p className={sectionBody}>
                Ao usar este site, você concorda em não tentar acessar áreas restritas sem
                autorização; não utilizar os formulários para envio de spam, conteúdo ofensivo ou
                ilegal; não tentar comprometer a segurança ou o funcionamento do site; e não
                utilizar dados obtidos no site para finalidades diferentes das previstas.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>5. Links externos</h2>
              <p className={sectionBody}>
                O site pode conter links para páginas de terceiros (redes sociais, WhatsApp,
                projetos de portfólio, Mercado Pago). Não temos controle sobre o conteúdo ou as
                práticas de privacidade desses sites externos e recomendamos a leitura das políticas
                próprias de cada um.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>6. Contratação de serviços</h2>
              <p className={sectionBody}>
                Orçamentos e contratos são formalizados individualmente com cada cliente, através de
                proposta enviada por e-mail/link com assinatura eletrônica. Pagamentos referentes a
                serviços contratados são processados por meio do{" "}
                <strong className="text-foreground">Mercado Pago</strong>, sujeitos também aos
                termos dessa plataforma. O uso do link de assinatura ou pagamento implica
                concordância com os valores, prazos e condições descritos na proposta específica.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>7. Limitação de responsabilidade</h2>
              <p className={sectionBody}>
                Nos esforçamos para manter o site sempre disponível e as informações atualizadas,
                mas não garantimos disponibilidade ininterrupta nem ausência total de erros. Não nos
                responsabilizamos por danos decorrentes de uso indevido do site ou de
                indisponibilidade temporária por motivos fora do nosso controle.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>8. Alterações destes termos</h2>
              <p className={sectionBody}>
                Estes Termos de Uso podem ser atualizados a qualquer momento. A data da última
                atualização está sempre indicada no topo desta página. O uso continuado do site após
                alterações implica concordância com a versão vigente.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>9. Lei aplicável e foro</h2>
              <p className={sectionBody}>
                Estes termos são regidos pelas leis brasileiras. Eventuais disputas serão resolvidas
                no foro do domicílio de Eliveuton Souza, salvo disposição diversa em contrato
                específico firmado com o cliente.
              </p>
            </section>

            <section className="mt-7">
              <h2 className={sectionTitle}>10. Contato</h2>
              <p className={sectionBody}>
                Dúvidas sobre estes Termos de Uso podem ser enviadas para{" "}
                <a href="mailto:eliveuton.dev@gmail.com" className={linkClass}>
                  eliveuton.dev@gmail.com
                </a>
                . Este documento tem caráter informativo e não substitui uma análise jurídica
                personalizada.
              </p>
            </section>
          </div>
        </div>
      </main>

      <FooterNew />
    </div>
  );
};

export default TermosDeUso;
